import './CRUDProposal.scss';
import './StandardText.scss';
import Component from './CRUDProposal';
export default Component;
